import type { IAttributes, IDirective, INgModelController } from "angular";
import { module } from "angular";
import { tz, utc } from "moment-timezone";

export default class DateFutureDirective implements IDirective {
    public restrict = "A";

    public require = "ngModel";

    public priority: 1;

    public link = (scope: any, el: JQuery, attributes: IAttributes, ctrl: INgModelController) => {
        ctrl.$validators.irDateFuture = (modelValue?: string) => {
            if (
                ctrl.$isEmpty(modelValue) ||
                !scope.dateFuture ||
                scope.$eval(attributes.ngDisabled) ||
                attributes.disabled
            ) {
                return true;
            }
            const timeZone = scope.timeZone || tz.guess();
            const now = utc().tz(timeZone);
            const modelValueAsMoment = tz(modelValue, `${scope.dateFormat} h:mm A`, timeZone);

            if (scope.ignoreTime) {
                return modelValueAsMoment.clone().startOf("day").isAfter(now.startOf("day"));
            }

            return modelValueAsMoment.isAfter(now);
        };
    };
}

module("mmGui").directive("irDateFuture", () => new DateFutureDirective());
